import { extractLanguageCode, getConfig, getLocale } from "@jti/fe-common";
import { type GetSearchResults, type SearchResponse } from "@jti/rest-api-types";

import { Rest } from "../services/Rest";

export class SearchApi extends Rest {
  readonly name = "SearchApi";
  constructor(
    baseUrl: string,
    evoTenant: string,
    protected lang: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-TENANT", evoTenant);
  }

  static init(): SearchApi {
    const config = getConfig();
    const locale = getLocale();

    return new SearchApi(config.EVO_DOMAIN, config.EVO_TENANT, locale);
  }

  async getSearchResults({
    queryParam,
    perPage,
    page,
    type,
    locale,
    highlight = true,
  }: GetSearchResults): Promise<SearchResponse> {
    const params = {
      q: queryParam,
      per_page: String(perPage),
      lang: locale || extractLanguageCode(this.lang),
      page: String(page),
      ...(type && { type }),
      highlight: String(Number(highlight)),
    };

    const { data, meta } = await this.request<SearchResponse>(`/api/search?${new URLSearchParams(params)}`, {}, true);

    return {
      data,
      meta,
    };
  }
}
